export default __webpack_public_path__ + "static/media/32.391816a2.png";